module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAARtJREFUSA2lllsOgjAQRYk7MK7EBcgK/JcVCC7BuFCNLsHolz8mRrwXGFO0hZlhkklLsef0QVOzDFHX9Rp5Q1Z8nhJg7JFXZN5wUCH8iWS8kTuvAH0PhHTxQJlz9Hdp6UqXBH1DuCAvFJRIQsMwSdAxBn+hfSPLVOHBJRmAF72lxg/NEjVcTBaJGW6RuOEayWT4iAT8v+DX0t9QgYyV6Bjb+NDgh4u8k4RQqavgMwENlIvEO/adJ97pmjHU2AmVGbA0nfieNQHnsrhOvBZeQBDbeP1MBkb+/RTdEg1cpmqWWOBmiQeulgDOO/Q3VIdIISl5o/GCDsMEH5GcKFgheUEzXPCEhP9Sls07VCg5I9s7VHo4SjC2yCOygX8Av80bgzQRmzgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/x.png
// module id = 141
// module chunks = 0 2